import React, { useRef } from 'react';
import './restauration.css';
import Restauration1 from './assets/p4.jpg';
import Restauration2 from './assets/p2.jpg';
import Restauration3 from './assets/p5.jpg';
import Restauration4 from './assets/p1.jpg';
import Restauration5 from './assets/p3.jpg';
import { RiRestaurantFill } from "react-icons/ri";
import { motion, useInView } from "framer-motion";
import { useNavigate } from 'react-router-dom';

const Restauration = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });
  const navigate = useNavigate();

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
        when: "beforeChildren",
        staggerChildren: 0.2
      }
    }
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.6, ease: "backOut" }
    },
    hover: {
      scale: 1.03,
      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
      transition: { duration: 0.3 }
    }
  };

  return (
    <div className="main-section-restauration" ref={ref} id='restauration'>
      <h1>Restaurant et Gastronomie</h1>
      <div>
        <motion.div
          className="Restauration"
          initial="hidden"
          animate={isInView ? "visible" : "hidden"}
          variants={containerVariants}
        >
          <motion.div 
            className="photo-frame"
            variants={containerVariants}
          >
            <motion.div 
              className="photo-grid"
              variants={containerVariants}
            >
              <motion.div 
                className="photo-item item-1"
                variants={imageVariants}
                whileHover="hover"
              >
                <img src={Restauration1} alt="Moules" />
              </motion.div>
              
              <motion.div 
                className="photo-item item-2"
                variants={imageVariants}
                whileHover="hover"
              >
                <img src={Restauration2} alt="Plat" />
              </motion.div>
              
              <motion.div 
                className="photo-item item-3"
                variants={imageVariants}
                whileHover="hover"
              >
                <img src={Restauration3} alt="Plat 1" />
              </motion.div>
              
              <motion.div 
                className="photo-item item-4"
                variants={imageVariants}
                whileHover="hover"
              >
                <img src={Restauration4} alt="Ambiance resto" />
              </motion.div>
              
              <motion.div 
                className="photo-item item-5"
                variants={imageVariants}
                whileHover="hover"
              >
                <img src={Restauration5} alt="Nouvelle image" />
              </motion.div>
            </motion.div>
          </motion.div>
          
          <motion.div 
            className="descriptionrestauration"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <h2><RiRestaurantFill className='iconR' /> Restauration</h2>
            <p>
              Découvrez une cuisine savoureuse dans nos deux restaurants: <br />
              <strong>TAJMAAT:</strong> 120 couverts à l'interieur, 200 en terrasse <br />
              <strong>Restaurant Istanbul:</strong> spécialité méditerranéennes 160 couverts <br />
              <strong>Deux cafétérias élégantes:</strong> Business Lounge et Salon de la Havane <br />
              Nos chefs vous proposent des buffets thématiques alliant saveurs locales et internationales, dans une ambiance conviviale et élégante.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Restauration;